<template>
<!-- data-wow-duration="2s" data-wow-delay=‘1s’ -->
  <div class="mobile_title_block  wow fadeInUp" >
    <h3 class="title_eng" @click="jumpServiceBFn(textChinese)" :class="colorIndex==='1'?'colorWhite':''">{{textEnglish}}</h3>
    <div  class="title_chi" v-if="showChineseIndex == 0">
      <p>—&nbsp;&nbsp;&nbsp;&nbsp;</p>
      <p @click="jumpServiceBFn(textChinese)"  :class="colorIndex==='1'?'colorWhite':''">{{textChinese}}</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;—</p>  
    </div>
  </div>
</template>

<script>
export default {
  name: 'titleBlock',
  props: {
    textChinese: {
      type: String,
      default: '',
    },
    textEnglish: {
      type: String,
      default: '',
    },
    flagIndex: {
      type: String,
      default: '0',
    },
    colorIndex: {
      type: String,
      default: '0',
    },
    showChineseIndex: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  methods:{
    jumpServiceBFn(textChinese) {
      if (this.flagIndex === '1') {
         document.documentElement.scrollTop = 0;
        if (textChinese === '服务项目'){
          this.$router.push({
            name: 'business',
          })
        } else if (textChinese === '案例展示'){
          this.$router.push({
            name: 'casepage',
          })
        }
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_title_block{
  width: 100%;
  height: auto;
  .title_eng{
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: bold;
    color: #e91d62;
    width: 100%;
    text-align: center;
  }
  .title_chi{
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #a4a4a4;
    margin-top: 4px;
  }
  .colorWhite{
    color:white
  }

}
</style>



